export const Role = {
    SystemAdmin: 'System Administrator',
    Admin: 'Administrator',
    Driver: 'Driver',
    YardStaff: 'Yard Staff',
    OfficeStaff: 'Office Staff',
    // Retained for compatibility; existing assignments are migrated to Office Staff.
    User: 'User',
} as const;

/** Organisation administrators (matches PrivateRoute admin guards). */
export const ADMIN_ROLES = [Role.Admin, Role.SystemAdmin] as const;
